/** Grams in one of a base unit that measures weight; null for count units (个, 箱, 卷...). */
const GRAMS = {
    g: 1,
    克: 1,
    kg: 1000,
    千克: 1000,
    公斤: 1000,
    斤: 500,
    t: 1_000_000,
    吨: 1_000_000,
};
export const gramsPer = (unit) => GRAMS[unit.trim().toLowerCase()] ?? null;
